import { render, staticRenderFns } from "./ConfigClientParam.vue?vue&type=template&id=671bbdb0&scoped=true"
import script from "./ConfigClientParam.vue?vue&type=script&lang=js"
export * from "./ConfigClientParam.vue?vue&type=script&lang=js"
import style0 from "./ConfigClientParam.vue?vue&type=style&index=0&id=671bbdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bbdb0",
  null
  
)

export default component.exports